import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {DescriptionIcon} from '../icon';

import styles from './description.module.css';

type Props = {
    description: string;
};

/**
 * Show a description icon, which shows the description on focus or hover.'
 */
export class Description extends React.PureComponent<Props> {
    componentDidMount() {
        ReactTooltip.rebuild();
    }

    UNSAFE_componentDidReceiveProps(nextProps: Props) {
        if (nextProps.description !== this.props.description) {
            ReactTooltip.rebuild();
        }
    }

    render() {
        return (
            <DescriptionIcon
                // @ts-expect-error
                tabIndex={0}
                data-tip={this.props.description}
                data-event='mouseenter focus'
                data-event-off='mouseleave blur click'
                className={styles.description}
            />
        );
    }
}
